<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container_1 pos-card card-vertical-center"
          style="flex: 0 0 23%"
        >
          <h4 class="stations_card_header_3">
            {{ $t("text.productSummary.total") }}
          </h4>
          <div class="oil_drop_div_4">
            <div class="text-center">
              <img src="@/assets/img/drop-of-liquid.png" width="50%" />
            </div>
          </div>
          <div class="mt-3 text-center">
            <h4 class="">
              {{
                convertThousand(
                  pmsSummary.volume +
                    agoSummary.volume +
                    dpkSummary.volume +
                    lpgSummary.volume
                )
              }}Ltrs
            </h4>
            <small class="dashboard__card__header_bottom"> </small>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section tank__bg"
          style="flex: 0 0 68%%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner" style="width: 100%; height: 150px">
            <div class="row align-items-center section__row">
              <div class="col-md-12 text-center section___column_1">
                <h4 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />{{
                    $t("text.sales.tankStock")
                  }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="row mt-3 w-100" v-if="showLoader">
        <div class="col-md-3 position-relative" v-for="(c, i) in 4" :key="i">
          <div class="card-loader"></div>
        </div>
      </section>
      <div class="row mt-3 pos_trans_card_holder" v-if="!showLoader">
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="hasPms"
        >
          <div class="card_container_1 pos-card mt-3 card-vertical-center">
            <h4 class="stations_card_header">
              {{ countryProducts.products.product1 }}
            </h4>
            <div class="oil_drop_div_1">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h4 class="">
                {{ convertThousand(pmsSummary.volume)
                }}{{ $t("text.sales.ltrs") }}
              </h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="!hasPms"
        >
          <div class="card_container_greyed pos-card mt-3 card-vertical-center">
            <h5 class="stations_card_header disabled-text">
              {{ $t("text.sales.pms") }}
            </h5>
            <div class="oil_drop_div_1 disabled-label-bg">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h5 class="">{{ $t("text.sales.nA") }}</h5>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="hasAgo"
        >
          <div class="card_container_1 pos-card mt-3 card-vertical-center">
            <h5 class="stations_card_header_1">
              {{ countryProducts.products.product2 }}
            </h5>
            <div class="oil_drop_div_2">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h4 class="">
                {{ convertThousand(agoSummary.volume)
                }}{{ $t("text.sales.ltrs") }}
              </h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="!hasAgo"
        >
          <div class="card_container_greyed pos-card mt-3 card-vertical-center">
            <h5 class="stations_card_header disabled-text">
              {{ $t("text.sales.nA") }}
            </h5>
            <div class="oil_drop_div_1 disabled-label-bg">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h5 class="">{{ $t("text.sales.nA") }}</h5>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="hasDpk"
        >
          <div class="card_container_1 pos-card mt-3 card-vertical-center">
            <h4 class="stations_card_header_2">
              {{ countryProducts.products.product3 }}
            </h4>
            <div class="oil_drop_div_3">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h4 class="">
                {{ convertThousand(dpkSummary.volume)
                }}{{ $t("text.sales.ltrs") }}
              </h4>
            </div>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="!hasDpk"
        >
          <div class="card_container_greyed pos-card mt-3 card-vertical-center">
            <h5 class="stations_card_header disabled-text">
              {{ $t("text.sales.dpk") }}
            </h5>
            <div class="oil_drop_div_1 disabled-label-bg">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h5 class="">{{ $t("text.sales.nA") }}</h5>
            </div>
          </div>
        </div>

        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="hasLpg"
        >
          <div class="card_container_1 pos-card mt-3 card-vertical-center">
            <h4 class="stations_card_header_1" style="color: purple">
              {{ countryProducts.products.product4 }}
            </h4>
            <div class="oil_drop_div_4" style="background: purple">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h4 class="">{{ convertThousand(lpgSummary.volume) }}Ltrs</h4>
              <small class="dashboard__card__header_bottom"> </small>
            </div>
          </div>
        </div>

        <div
          class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
          :class="productCount"
          v-if="!hasLpg"
        >
          <div class="card_container_greyed pos-card mt-3 card-vertical-center">
            <h5 class="stations_card_header disabled-text">
              {{ $t("text.sales.lpg") }}
            </h5>
            <div class="oil_drop_div_1 disabled-label-bg">
              <div class="text-center">
                <img src="@/assets/img/drop-of-liquid.png" width="50%" />
              </div>
            </div>
            <div class="mt-3 text-center">
              <h5 class="">{{ $t("text.sales.nA") }}</h5>
            </div>
          </div>
        </div>
      </div>

      <section v-show="!showLoader" class="mobile_tanks_filled">
        <div class="dashboard__table__section mt-3">
          <div class="branch__sales__text_header">
            <div class="row">
              <div class="col-md-8">
                <span> </span>
              </div>
              <div class="col-md-4 text-right"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :allowTextWrap="true"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="branchName"
                  width="250"
                  :headerText="$t('text.sales.stationName')"
                ></e-column>
                <e-column
                  field="region"
                  width="280"
                  :headerText="$t('text.sales.region')"
                ></e-column>

                <e-column
                  field="state"
                  width="200"
                  :headerText="$t('text.sales.state')"
                ></e-column>
                <e-column
                  field="pmsVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.sales.pmsVolume')"
                  :visible="hasPms ? true : false"
                ></e-column>
                <e-column
                  field="agoVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.sales.agoVolume')"
                  :visible="hasAgo ? true : false"
                ></e-column>
                <e-column
                  field="dpkVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.sales.dpkVolume')"
                  :visible="hasDpk ? true : false"
                ></e-column>
                <e-column
                  field="lpgVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.sales.lpgVolume')"
                  :visible="hasLpg ? true : false"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
      <section class="mt-5" style="margin: 0 auto; width: 96%">
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import configObject from "@/config";
import countryProducts from "@/products";

import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Tank Stock :: Epump Portal",
  name: "TanksFilled",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/mm/yyyy" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: this.startDate,
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      tanks: [],
      backgroundUrl,
      showLoader: false,
      groupId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      startDate: this.$moment().format("MMMM D, YYYY"),
      today: this.$moment().format("MMMM D, YYYY"),
      monthAgo: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      disabledDates: [],
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,

      productSummary: [],
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      productSummaryCount: 0,
      productCount: "col-lg-3",
      group: null,
    };
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    if (this.$route.query.groupId) {
      this.getTankStock();
    }
    this.dateRange = this.pluginStartDate;
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  watch: {
    group(group) {
      if (group !== null) {
        this.getTankStock();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    displayProductSummary(productSummary) {
      let prodCount = 0;
      let summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "pms"
      );
      if (summary && summary.length > 0) {
        this.pmsSummary = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasPms = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "ago"
      );
      if (summary && summary.length > 0) {
        this.agoSummary = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasAgo = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "dpk"
      );
      if (summary && summary.length > 0) {
        this.dpkSummary = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasDpk = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "lpg"
      );
      if (summary && summary.length > 0) {
        this.lpgSummary = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasLpg = true;
        prodCount++;
      }
      prodCount++;
      let columnNumber;
      prodCount !== 5 ? (columnNumber = 12 / prodCount) : (columnNumber = 3);
      this.productCount = `col-lg-${columnNumber}`;
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "lastDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    getTankStock() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/GroupTankStock/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.displayProductSummary(response.data);
          this.showLoader = false;
          const groups = response.data.reduce((groups, sales) => {
            const branchName = sales.branchName;
            if (!groups[branchName]) {
              groups[branchName] = [];
            }
            groups[branchName].push(sales);
            return groups;
          }, {});

          let count = 0;
          const groupArrays = Object.keys(groups).map((branchName) => {
            let agoVolume = 0;
            let pmsVolume = 0;
            let dpkVolume = 0;
            let lpgVolume = 0;
            groups[branchName].forEach((branch) => {
              if (branch.productName === "PMS") {
                this.hasPms = true;
                pmsVolume = pmsVolume + branch.currentVolume;
              }
              if (branch.productName === "AGO") {
                this.hasAgo = true;
                agoVolume = agoVolume + branch.currentVolume;
              }
              if (branch.productName === "DPK") {
                this.hasDpk = true;
                dpkVolume = dpkVolume + branch.currentVolume;
              }
              if (branch.productName === "LPG") {
                this.hasLpg = true;
                lpgVolume = lpgVolume + branch.currentVolume;
              }
            });

            count++;
            return {
              index: count,
              branchName,
              region: groups[branchName][0].branchRegion,
              state: groups[branchName][0].branchState,
              pmsVolume: pmsVolume,
              agoVolume: agoVolume,
              dpkVolume: dpkVolume,
              lpgVolume: lpgVolume,
            };
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: groupArrays,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (request === null || request === "null") {
        return "0.00";
      }
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
